module.exports = __webpack_public_path__ + "img/-s-icon04.67793bf2.png";